// extracted by mini-css-extract-plugin
export default {"tabContainer":"TimeSlotTabHeader-module__tabContainer___yi4Ns","tabHeader":"TimeSlotTabHeader-module__tabHeader___1wsuw"};